const slugify = (text) => {
  if (!text) return '';
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrssssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return text.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

const collectionMapping = {
    "projects": "projekti",
    "practices": "prakse",
    "posts": "zapisi",
    "kinships": "sorodstva"
}

export const getSlug = (item, language, collection) => {
  // Always use Slovenian slug for URLs to maintain consistent Slovenian URL structure
  const slug = item.metadata[`slug_sl`] || item.metadata.slug || slugify(item.metadata.title);
  const slovenianCollection = collectionMapping[collection] || collection;
  return `/${slovenianCollection}/${slug}`;
};

export const translations = {
    sl: {
        fundedBy: 'Financirano s strani',
        molTitle: 'Mestna občina Ljubljana',
        molDept1: 'Oddelek za varstvo okolja',
        molDept2: 'Urad za mladino',
        navHome: 'Domov',
        navProjects: 'Prepletanja',
        navPractices: 'Utelešenja',
        navForOurKin: 'Sorodstva',
        navBiodiversity: 'Biodiverziteta',
        navGallery: 'Galerija',
        navCalendar: 'Koledar',
        navPosts: 'Zapisi',
        sensorDataTitle: 'livada.bio občuti zemljo',
        projectFutureDesc: 'V tem prepletanju ne merimo, temveč poslušamo šepet prsti, ki nam pripoveduje o vlagi, temperaturi in življenju pod površjem. Podatki se osvežujejo vsako uro.',
        biodiversityTitle: 'Barjanski travnik',
        biodiversityDesc: 'Dom številnih sorodnikov.',
        biodiversityDescription: 'Razišči zbirko s prebivalci Biotopa Livada. Večina opazovanj je nastala med rednimi srečanji in monitoringi, ki jih organiziramo na Livadi. Če bi v zbirki rada_ videla_ tudi svoje fotografije, se nam lahko pridružiš na monitoringu na Livadi in prispevaš svoja opažanja preko platforme iNaturalist. Vsa opažanja na tej mikrolokaciji (opremljena z geokoordinatami Biotopa Livada ali bližnje okolice) se samodejno vpišejo v naš namenski projekt na omenjeni plaformi.',
        practicesTitle: 'Prakse',
        practicesDesc: 'Skupnost za deljenje raznovrstnih praks.',
        calendarTitle: 'Koledar dogodkov',
        calendarDesc: 'Naši prihajajoči dogodki, delavnice in srečanja. Pridruži se nam on četrtkih in sobotah od marca do konca oktobra!',
        galleryPageDescription: 'Razišči galerije s fotografijami naših aktivnosti.',
        recentObservations: 'Nedavna opazovanja',
        loading: 'Nalagam',
        loadMore: 'Naloži dodatna',
        noMoreObservations: 'Ni več opazovanj.',
        fetchError: 'Napaka pri pridobivanju podatkov',
        processingError: 'Napaka pri obdelavi podatkov',
        dataUpdated: 'Podatki so osveženi',
        lastUpdated: 'Zadnja meritev',
        refreshData: 'Osveži podatke',
        noChartData: 'Ni dovolj podatkov za prikaz grafa.',
        noSensorData: 'Ni podatkov o senzorjih',
        noUpcomingEvents: 'Trenutno ni napovedanih dogodkov.',
        noEventsFound: 'Ni najdenih dogodkov v koledarju.',
        calendarFetchError: 'Napaka pri pridobivanju dogodkov iz koledarja.',
        openInGoogleCalendar: 'Odpri v Google Koledarju',
        moistureFlows: 'Vlaga v zraku in prsti',
        temperatureFlows: 'Temperatura zraka in prsti',
        temperature: 'Temperatura',
        soilTemp: 'Temperatura prsti',
        airTemp: 'Temperatura zraka',
        historicalSensorDataTitle: 'Beleženje',
        footerText: 'Biotop Livada – posebna pobuda v okviru zavoda BOB © 2025',
        photoBy: 'Foto',
        navMemoryGame: 'Spomin',
        memoryGameTitle: 'Spomin',
        moves: 'poteze',
        playAgain: 'nova igra',
        slovenian: 'SL',
        english: 'EN',
        latin: 'strokovna imena',
        close: 'Zapri',
        previous: 'Prejšnja',
        next: 'Naslednja',
        backToCollection: 'Nazaj na seznam',
        memoryGameDescription: 'V igri so uporabljeni posnetki, zbrani med rednimi monitoringi v Biotopu Livada, celotno zbirko lahko pogledaš na odseku biodiverziteta. Če bi v igri rada_ videla_ tudi svoje fotografije, se nam lahko pridružiš na monitoringu na Livadi in prispevaš svoja opažanja preko platforme iNaturalist. Vsa opažanja na tej mikrolokaciji (opremljena z geokoordinatami LivadaLAB ali bližnje okolice) se samodejno vpišejo v naš namenski projekt na omenjeni plaformi.',
        congratulations: 'Čestitamo!',
        yourScore: 'Tvoj rezultat:',
        enterName: 'Vpiši ime za lestvico:',
        submitScore: 'Shrani rezultat',
        hallOfFame: 'Lestvica najboljših',
        player: 'Bitje',
        score: 'Točke',
        newGame: 'Nova igra',
        noScores: 'Ni še rezultatov',
        date: 'Datum',
        beTheFirstToSubmitScore: 'Pošlji prvi rezultat!',
        leaderboardAutoInfo: 'Rezultati se samodejno shranijo.',
        leaderboardAutoSuccess: 'Tvoj rezultat je bil dodan na lestvico!',
        openInINaturalist: 'Odpri v iNaturalistu',
        openInWikipedia: 'Odpri v Wikipediji',
        loadingDescription: 'Nalagam opis...',
        openPortal: 'Razširi portal',
        closePortal: 'Zapri portal',
        noDescriptionFoundOnSlWikipedia: 'Nima opisa na slovenski Wikipediji.',
        postsTitle: 'Zapisi',
        postsDesc: 'Naši zapisi o livadi.',
        steps: 'Koraki',
        step: 'Korak',
        allTags: 'vse',
        victory: 'Zmaga!',
        victoryMessage: 'Uspešno si končal_ igro!',
        pridiNaMonitoring: 'Pridi na monitoring',
        findPair: 'Najdi par',
        metrics: 'Metrike',
        hideAll: 'Skrij vse',
        showAll: 'Prikaži vse',
        bedFilters: 'Filtri za postajice',
        fetchingHistoricalData: 'Pridobivam zgodovinske podatke',
        // Graph interface translations
        last7Days: 'Zadnjih 7 dni',
        last30Days: 'Zadnjih 30 dni',
        last90Days: 'Zadnjih 90 dni',
        last6Months: 'Zadnjih 6 mesecev',
        customRange: 'Po meri',
        startDate: 'Začetni datum',
        endDate: 'Končni datum',
        days: 'dni',
        refresh: 'Osveži',
        apply: 'Uporabi',
        cancel: 'Prekliči',
        zoomIn: 'Približaj',
        zoomOut: 'Oddalji',
        panLeft: 'Premakni levo',
        panRight: 'Premakni desno',
        resetView: 'Ponastavi pogled',
        reset: 'Ponastavi',
        values: 'Vrednosti',
        noDataForSelectedPeriod: 'Ni podatkov za izbrano obdobje',
        soilMoistureFull: 'Vlaga v prsti',
        soilTemperatureFull: 'Temperatura prsti',
        airTemperatureFull: 'Temperatura zraka',
        airHumidityFull: 'Vlaga v zraku',
        raw: 'Surovi',
        // Wind metrics
        windSpeed: 'hitrost vetra',
        windGust: 'sunki vetra',
        windDirection: 'smer vetra',
        windCompass: 'smer vetra',
        weatherStation: 'vremenska postaja',
        // Compass directions
        north: 'Sever',
        south: 'Jug',
        east: 'Vzhod',
        west: 'Zahod',
        northeast: 'Severovzhod',
        southeast: 'Jugovzhod',
        southwest: 'Jugozahod',
        northwest: 'Severozahod',
        northNorthEast: 'Sever-severovzhod',
        eastNorthEast: 'Vzhod-severovzhod',
        eastSouthEast: 'Vzhod-jugovzhod',
        southSouthEast: 'Jug-jugovzhod',
        southSouthWest: 'Jug-jugozahod',
        westSouthWest: 'Zahod-jugozahod',
        westNorthWest: 'Zahod-severozahod',
        northNorthWest: 'Sever-severozahod',
        // PAX counter metrics
        paxCounter: 'PAX števec',
        paxWifi: 'WiFi naprave',
        paxBle: 'BLE naprave',
        paxTotal: 'skupaj naprav',
        // Sensors2025.jsx translations
        noDataForMonth: 'Ni podatkov za ta mesec.',
        time: 'Čas',
        soilMoisture: 'Vlaga v prsti',
        soilTemperature: 'Temperatura prsti',
        airTemperature: 'Temperatura zraka',
        airHumidity: 'Vlaga v zraku',
        airPressure: 'Tlak',
        gasResistance: 'Plinski upor',
        iaqIndex: 'IAQ indeks',
        beds: 'Postajice',
        all: 'Vse',
        noSoilDataForMonth: 'Ni podatkov o prsti za izbrani mesec.',
        noWeatherDataForMonth: 'Ni vremenskih podatkov za izbrani mesec.',
        moistureInSoil: '🌱 Vlaga v prsti (%)',
        soilTempTitle: '🌡 Temperatura prsti (°C)',
        airTempHumidity: '☁️ Temperatura in vlaga zraka',
        pressureIAQGas: '📊 Tlak · IAQ · plinski upor',
        downloadCSV: '⬇ CSV ({count} datotek)',
        archive2025: 'Beleženje · arhiv 2025',
        juneToNov2025: 'junij – november 2025',
        // Bed names - Orchard/Sadovnjak and Garden/Vrt (current active beds)
        bedOrchard1: 'sadovnjak 1',
        bedOrchard2: 'sadovnjak 2',
        bedGarden1: 'vrt 1',
        bedGarden2: 'vrt 2',
        // Legacy bed names (kept for backward compatibility with historical data)
        bedBarjanskoRastje: 'barjansko rastje',
        bedCvetliceZaOprasevalce: 'cvetlice za opraševalce',
        bedMajaronInMelisa: 'majaron in melisa',
        bedTolscakInSlezenovec: 'tolščak in slezenovec',
        bedTravnatiSestoj: 'travnati sestoj',
        bedSivkaInMelisa: 'sivka in melisa',
        // Month labels
        monthJune2025: 'junij 2025',
        monthJuly2025: 'julij 2025',
        monthAugust2025: 'avgust 2025',
        monthSeptember2025: 'september 2025',
        monthOctober2025: 'oktober 2025',
        monthNovember2025: 'november 2025',
        // Bluesky translations
        followOnBluesky: 'Sledi nam na Bluesky',
        // Form translations
        contactFormTitle: 'Stik',
        contactFormDescription: 'Imaš vprašanje ali predlog?',
        nameLabel: 'Ime in priimek',
        emailLabel: 'E-pošta',
        messageLabel: 'Sporočilo',
        sendButton: 'Pošlji',
        forOurKinFormTitle: 'Kaj vse lahko človek podari travniku?',
        forOurKinFormDescription: 'S spodnjim obrazcem nam lahko posreduješ svoj predlog.',
        initiativeNameLabel: 'Naslov predloga',
        initiativeDescriptionLabel: 'Opis predloga',
        fullNameLabel: 'Ime in priimek',
        initiativeLink: 'Povezava do dodatne dokumentacije (ni obvezna)',
        // Form submission messages
        formSuccessMessage: 'Sporočilo je bilo uspešno poslano!',
        formErrorMessage: 'Prišlo je do napake pri pošiljanju sporočila. Prosimo, poskusi znova.',
        botFieldLabel: 'Ne izpolnite, če ste človek:',
        routes: {
            home: '', // Home path is just '/'
            projects: 'prepletanja',
            practices: 'utelesenja',
            kinships: 'sorodstva',
            biodiversity: 'biodiverziteta',
            gallery: 'galerija',
            calendar: 'koledar',
            posts: 'zapisi',
            memoryGame: 'spomin',
            leaderboard: 'lestvica',
        }
    },
    en: {
        navHome: 'Home',
        navProjects: 'Intertwinings',
        navPractices: 'Embodiments',
        navForOurKin: 'Kinships',
        navBiodiversity: 'Biodiversity',
        navGallery: 'Gallery',
        navCalendar: 'Calendar',
        navPosts: 'Writings',
        postsTitle: 'Writings',
        postsDesc: 'Journaling stories of more than human and soil.',
        steps: 'Steps',
        step: 'Step',
        allTags: 'All',
        sensorDataTitle: 'livada.bio senses the soil',
        projectFutureDesc: 'In this intertwining, we don\'t just measure; we listen to the whisper of the soil, which tells us stories of moisture, temperature, and life beneath the surface. Data is updated hourly.',
        biodiversityTitle: 'Wetlands meadow',
        biodiversityDesc: 'Home of our kin',
        biodiversityDescription: 'Explore the collection with the residents of the Livada Biotope. Most of the observations were made during regular meetings and monitoring sessions organised at the site. If you would like to see your photos in the collection, you can join us at the monitoring sessions and contribute your observations via the iNaturalist platform. All observations at this micro-location (equipped with the geocoordinates of the Livada Biotope or the surrounding area) are automatically entered into our dedicated project on the aforementioned platform.',
        practicesTitle: 'Practices',
        practicesDesc: 'Community for sharing of diverse practices',
        calendarTitle: 'Calendar of Events',
        calendarDesc: 'Our upcoming events, workshops, and gatherings. Join us on Thursdays and Saturdays afternoon from March to end of October!',
        galleryPageDescription: 'Explore galleries of our activities.',
        recentObservations: 'Recent Observations',
        loading: 'Loading',
        loadMore: 'Load More',
        noMoreObservations: 'No more observations.',
        fetchError: 'Error fetching data',
        processingError: 'Error processing data',
        dataUpdated: 'Data updated',
        lastUpdated: 'Last measurement',
        refreshData: 'Refresh Data',
        noChartData: 'Not enough data to display the chart.',
        noSensorData: 'No sensor data available',
        noUpcomingEvents: 'No upcoming events scheduled at this time.',
        noEventsFound: 'No events found in the calendar.',
        calendarFetchError: 'Error fetching events from calendar.',
        openInGoogleCalendar: 'Open in Google Calendar',
        moistureFlows: 'Moisture Flows',
        temperatureFlows: 'Temperature Flows',
        temperature: 'Temperature',
        soilTemp: 'Soil Temperature',
        airTemp: 'Air Temperature',
        historicalSensorDataTitle: 'Data Collection',
        footerText: 'The Livada Biotope – special initiative within BOB Institute © 2025',
        photoBy: 'Photo',
        navMemoryGame: 'Game',
        memoryGameTitle: 'Memory Game',
        moves: 'Moves',
        playAgain: 'Play Again',
        slovenian: 'Slovenian',
        english: 'English',
        latin: 'Latin',
        close: 'Close',
        previous: 'Previous',
        next: 'Next',
        backToCollection: 'Back to collection',
        // Form translations
        contactFormTitle: 'Contact Form',
        contactFormDescription: 'Do you have a question or suggestion? Write to us!',
        nameLabel: 'Name',
        emailLabel: 'Email',
        messageLabel: 'Message',
        forOurKinFormTitle: 'What can a human give to the meadow?',
        forOurKinFormDescription: 'Would you like to contribute to Kinships? Fill out the form bellow.',
        initiativeNameLabel: 'Name of contribution',
        initiativeDescriptionLabel: 'Description of contribution',
        fullNameLabel: 'Full name',
        initiativeLink: 'Link to contribution documentation (optional)',
        sendButton: 'Send',
        // Form submission messages
        formSuccessMessage: 'Your message has been sent successfully!',
        formErrorMessage: 'An error occurred while sending the message. Please try again.',
        botFieldLabel: 'Don\'t fill this out if you\'re human:',
        memoryGameDescription: 'The Memory game uses images collected during regular monitoring in the Livada Biotope. You can view the entire collection in the biodiversity section. If you would like to see your photos in the game, you can join us in monitoring at Livada and contribute your observations via the iNaturalist platform. All observations in this microlocation (marked with the coordinates of LivadaLAB or its immediate vicinity) are automatically added into our dedicated project on the mentioned platform.',
        congratulations: 'Congratulations!',
        yourScore: 'Your score:',
        enterName: 'Enter name for leaderboard:',
        submitScore: 'Save Score',
        hallOfFame: 'Hall of Fame',
        player: 'Player',
        score: 'Score',
        newGame: 'New Game',
        noScores: 'No scores yet',
        date: 'Date',
        beTheFirstToSubmitScore: 'Be the first to submit a score!',
        leaderboardAutoInfo: 'Scores are automatically saved and displayed without rebuilding the site.',
        leaderboardAutoSuccess: 'Your score has been automatically added to the leaderboard!',
        openInINaturalist: 'Open in iNaturalist',
        openInWikipedia: 'Open in Wikipedia',
        loadingDescription: 'Loading description...',
        openPortal: 'Open Portal',
        closePortal: 'Close Portal',
        noDescriptionFoundOnSlWikipedia: 'No description on Slovenian Wikipedia.',
        victory: 'Victory!',
        victoryMessage: 'You have successfully completed the game!',
        pridiNaMonitoring: 'Join the monitoring',
        findPair: 'Find a pair',
        metrics: 'Metrics',
        hideAll: 'Hide all',
        showAll: 'Show all',
        bedFilters: 'Bed filters',
        fetchingHistoricalData: 'Fetching historical data',
        // Graph interface translations
        last7Days: 'Last 7 days',
        last30Days: 'Last 30 days',
        last90Days: 'Last 90 days',
        last6Months: 'Last 6 months',
        customRange: 'Custom range',
        granularity: 'Granularity',
        startDate: 'Start date',
        endDate: 'End date',
        days: 'days',
        refresh: 'Refresh',
        raw: 'Raw',
        hourly: 'Hourly',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        apply: 'Apply',
        cancel: 'Cancel',
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        panLeft: 'Pan left',
        panRight: 'Pan right',
        resetView: 'Reset view',
        reset: 'Reset',
        export: 'Export',
        exportAsPNG: 'Export as PNG',
        exportAsJPG: 'Export as JPG',
        exportAsPDF: 'Export as PDF',
        exportAsCSV: 'Export as CSV',
        values: 'Values',
        exportingAs: 'Exporting as',
        noDataForSelectedPeriod: 'No data for selected period',
        soilMoistureFull: 'Soil moisture',
        soilTemperatureFull: 'Soil temperature',
        airTemperatureFull: 'Air temperature',
        airHumidityFull: 'Air humidity',
        // Wind metrics
        windSpeed: 'wind speed',
        windGust: 'wind gust',
        windDirection: 'wind direction',
        windCompass: 'wind direction',
        // Compass directions
        north: 'North',
        south: 'South',
        east: 'East',
        west: 'West',
        northeast: 'Northeast',
        southeast: 'Southeast',
        southwest: 'Southwest',
        northwest: 'Northwest',
        northNorthEast: 'North-northeast',
        eastNorthEast: 'East-northeast',
        eastSouthEast: 'East-southeast',
        southSouthEast: 'South-southeast',
        southSouthWest: 'South-southwest',
        westSouthWest: 'West-southwest',
        westNorthWest: 'West-northwest',
        northNorthWest: 'North-northwest',
        // PAX counter metrics
        paxCounter: 'PAX counter',
        paxWifi: 'WiFi devices',
        paxBle: 'BLE devices',
        paxTotal: 'total devices',
        // Sensors2025.jsx translations
        noDataForMonth: 'No data for this month.',
        time: 'Time',
        soilMoisture: 'Soil moisture',
        soilTemperature: 'Soil temperature',
        airTemperature: 'Air temperature',
        airHumidity: 'Air humidity',
        airPressure: 'Pressure',
        gasResistance: 'Gas resistance',
        iaqIndex: 'IAQ index',
        beds: 'Beds',
        all: 'All',
        noSoilDataForMonth: 'No soil data for the selected month.',
        noWeatherDataForMonth: 'No weather data for the selected month.',
        moistureInSoil: '🌱 Soil moisture (%)',
        soilTempTitle: '🌡 Soil temperature (°C)',
        airTempHumidity: '☁️ Air temperature and humidity',
        pressureIAQGas: '📊 Pressure · IAQ · gas resistance',
        downloadCSV: '⬇ CSV ({count} files)',
        archive2025: 'Data Collection · archive 2025',
        juneToNov2025: 'June – November 2025',
        // Bed names - Orchard/Sadovnjak and Garden/Vrt (current active beds)
        bedOrchard1: 'orchard 1',
        bedOrchard2: 'orchard 2',
        bedGarden1: 'garden 1',
        bedGarden2: 'garden 2',
        // Legacy bed names (kept for backward compatibility with historical data)
        bedBarjanskoRastje: 'marsh plants',
        bedCvetliceZaOprasevalce: 'flowers for pollinators',
        bedMajaronInMelisa: 'marjoram and lemon balm',
        bedTolscakInSlezenovec: 'purslane and mallow',
        bedTravnatiSestoj: 'grassy stand',
        bedSivkaInMelisa: 'lavender and lemon balm',
        // Month labels
        monthJune2025: 'June 2025',
        monthJuly2025: 'July 2025',
        monthAugust2025: 'August 2025',
        monthSeptember2025: 'September 2025',
        monthOctober2025: 'October 2025',
        monthNovember2025: 'November 2025',
        // Bluesky translations
        followOnBluesky: 'Follow us on Bluesky',
        routes: {
            home: '', // Home path is just '/'
            projects: 'intertwinings',
            practices: 'embodiments',
            kinships: 'kinships',
            biodiversity: 'biodiversity',
            gallery: 'gallery',
            calendar: 'calendar',
            posts: 'writings',
            memoryGame: 'memory-game',
            leaderboard: 'leaderboard',
        }
    }
};
